import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import config from './Config/config.json';
import { LoginForm } from './Login/LogIn';
import Logout from './Logout/LogOut';
import LoyaltyDashboard from './BackEnd/Dashboard/LoyaltyDashboard';
import { getLocalValue, LoacalVariables, setLocalValues } from './commonFunctions/CommonFunctions';
import Unauthorized from './Unauthorized';
import { setLogoutHandler } from './helpers/logoutHandler';
const SESSION_TIMEOUT = config.sessionTimeOut * 60 * 1000; // 15 minutes

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(getLocalValue(LoacalVariables.UserToken));
  const [lastActivity, setLastActivity] = useState<number>(Date.now());

  useEffect(() => {
    if (!token) return;

    const handleActivity = () => {
      setLastActivity(Date.now());
    };

    // Add event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    const checkTimeout = () => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        handleLogout(); // Logout the user after inactivity
        window.location.reload();
      }
    };

    const intervalId = setInterval(checkTimeout, 1000); // Check for timeout every second

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, [lastActivity, token]);

  const handleLogin = (newToken: string, refreshToken: string, email: string, name: string, role: string) => {
    setToken(newToken);
    setLocalValues(LoacalVariables.UserToken, newToken);
    setLocalValues(LoacalVariables.RefreshToken, refreshToken);
    setLocalValues(LoacalVariables.UserMailId, email);
    setLocalValues(LoacalVariables.UserName, name);
    setLocalValues(LoacalVariables.UserType, role);
  };

  const handleLogout = useCallback(() => {
    setToken(null);
    localStorage.clear();
  }, []);

  useEffect(() => {
    setLogoutHandler(handleLogout);
  }, [handleLogout]);

  return (
    <>
      <Router>
        <CssBaseline />
        <Routes>
          {/* Route for Login */}
          <Route path="/login" element={token !== null ? <Navigate to="/" /> : <LoginForm onLogin={handleLogin} />} />
          <Route path="/logout" element={<Logout />} />
          <Route path='/unauthorized' element={<Unauthorized />} />

          {/* Protect the routes with PrivateRoute for authentication */}
          <Route path="/" element={token ? <DashboardLayout /> : <Navigate to="/login" />}>
            <Route index element={token ? <LoyaltyDashboard /> : <Navigate to="/login" />} />
            <Route path="/*" element={token ? <PrivateRoute token={token} /> : <Navigate to="/login" />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
